document.addEventListener('DOMContentLoaded', function() {
  var isHome = (window.location.pathname === '/' || window.location.pathname === '/index.html');

  const header = document.querySelector('header');
  if (!header) return;

  const mobileHeader = header.querySelector('.lg\\:hidden');
  const desktopHeader = header.querySelector('.lg\\:block');
  if (!mobileHeader || !desktopHeader) return;

  const mobileContainer = mobileHeader.querySelector('.flex.items-center');
  const desktopContainer = desktopHeader.querySelector('.grid');
  const mobileIcons = mobileHeader.querySelector('.absolute.right-6');
  const logos = header.querySelectorAll('img');

  function updateHeader() {
    const scrolled = window.scrollY > 50;
    const isMobile = window.innerWidth < 1024;

    if (isHome && !scrolled) {
      mobileHeader.style.backgroundColor = 'transparent';
      desktopHeader.style.backgroundColor = 'transparent';
      desktopHeader.classList.add('gradient-blur-header');
    } else {
      mobileHeader.style.backgroundColor = '#001689';
      desktopHeader.style.backgroundColor = '#001689';
      desktopHeader.classList.remove('gradient-blur-header');
    }

    if (scrolled) {
      mobileContainer.style.paddingTop = '0.75rem';
      mobileContainer.style.paddingBottom = '0.75rem';
      mobileIcons.style.top = '0.75rem';
      desktopContainer.style.height = '5rem';

      logos.forEach(function(logo) {
        logo.style.height = isMobile ? '45px' : '55px';
      });
    } else {
      mobileContainer.style.paddingTop = '1rem';
      mobileContainer.style.paddingBottom = '1rem';
      mobileIcons.style.top = '1rem';
      desktopContainer.style.height = '7rem';

      logos.forEach(function(logo) {
        logo.style.height = isMobile ? '60px' : '80px';
      });
    }
  }

  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });
  window.addEventListener('resize', updateHeader, { passive: true });
});

// === ЛОГИКА МОБИЛЬНОГО МЕНЮ (СПРАВА + СТРАНЫ) ===
document.addEventListener('DOMContentLoaded', function() {
  // 1. Собираем ссылки основного меню с десктопной версии
  const desktopNavs = document.querySelectorAll('.lg\\:block nav a, .lg\\:block nav button.country-menu-trigger');
  let mainMenuItems = [];

  desktopNavs.forEach(link => {
    const href = link.getAttribute('href') || link.getAttribute('data-href') || '#';
    // Если это кнопка Country или ссылка на #country, помечаем
    const isCountryTrigger = href === '#country' || link.classList.contains('country-menu-trigger') || link.textContent.trim().toLowerCase().includes('country');
    
    const text = link.textContent.trim();
    
    if (text) {
      mainMenuItems.push({ 
        href: isCountryTrigger ? '#country' : href, 
        text: text,
        isCountry: isCountryTrigger
      });
    }
  });
  
  // Добавляем хардкодом "Send message", если его нет
  const hasMessage = mainMenuItems.some(i => i.href === '#message');
  if (!hasMessage) {
     const countryIndex = mainMenuItems.findIndex(i => i.isCountry);
     if (countryIndex !== -1) {
        mainMenuItems.splice(countryIndex, 0, { href: '#message', text: 'Send message', isCountry: false });
     } else {
        mainMenuItems.push({ href: '#message', text: 'Send message', isCountry: false });
     }
  }

  // 2. Получаем ссылки стран (переданные из header.liquid)
  const countryItems = window.countryMenuItems || [];

  // 3. Создаем HTML оболочку (ПРАВАЯ СТОРОНА)
  // Добавлены классы: .mobile-menu-overlay, .mobile-menu-panel, .mobile-menu-close, .mobile-menu-nav
  const menuWrapperHTML = `
    <div id="mobile-menu-overlay" class="mobile-menu-overlay" style="display: none;">
      <div id="mobile-menu-panel" class="mobile-menu-panel">
        <button id="mobile-menu-close" class="mobile-menu-close" aria-label="Close menu">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mobile-menu-close-icon">
            <path d="M18 6 6 18"></path><path d="m6 6 12 12"></path>
          </svg>
        </button>
        <nav id="mobile-menu-nav" class="mobile-menu-nav">
          </nav>
      </div>
    </div>
  `;

  // Вставляем оболочку, если ее еще нет
  if (!document.getElementById('mobile-menu-overlay')) {
    document.body.insertAdjacentHTML('beforeend', menuWrapperHTML);
  }

  // Элементы DOM
  const menuToggleButton = document.querySelector('header button[aria-label="Toggle menu"]') || document.getElementById('mobile-menu-trigger-btn');
  const overlay = document.getElementById('mobile-menu-overlay');
  const panel = document.getElementById('mobile-menu-panel');
  const closeButton = document.getElementById('mobile-menu-close');
  const navContainer = document.getElementById('mobile-menu-nav');

  if (!menuToggleButton) return;

  // --- ФУНКЦИИ РЕНДЕРИНГА ---

  function renderMain() {
    const html = mainMenuItems.map((item, index) => {
      // Добавлен класс .mobile-menu-link
      // Убраны инлайн-стили для шрифта, border и padding (перенесены в CSS)
      const isLast = index === mainMenuItems.length - 1;
      const extraClass = isLast ? 'mobile-menu-link--last' : '';
      const countryClass = item.isCountry ? 'js-country-trigger' : '';
      
      return `<a href="${item.href}" class="mobile-menu-link ${extraClass} ${countryClass}">${item.text}</a>`;
    }).join('');
    
    navContainer.innerHTML = html;
    attachLinkListeners(); // Переназначаем обработчики
  }

  function renderCountry() {
    // Кнопка "Назад" с классом .mobile-menu-back
    let html = `
      <button id="js-back-menu" class="mobile-menu-back">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" class="mobile-menu-back-icon"><path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" /></svg>
        Back
      </button>
    `;

    html += countryItems.map((item) => {
      // Ссылки стран используют тот же класс .mobile-menu-link
      return `<a href="${item.url}" target="_blank" class="mobile-menu-link">${item.title}</a>`;
    }).join('');

    navContainer.innerHTML = html;
    
    // Обработчик кнопки "Назад"
    const backBtn = document.getElementById('js-back-menu');
    if(backBtn) {
        backBtn.addEventListener('click', function(e) {
          e.preventDefault();
          renderMain();
        });
    }
  }

  function attachLinkListeners() {
    // Обработка клика по "Select Country"
    const countryLinks = navContainer.querySelectorAll('.js-country-trigger, a[href="#country"]');
    countryLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation(); // Важно, чтобы не сработал глобальный закрыватель
        renderCountry();
      });
    });

    // Обработка обычных ссылок (закрытие меню)
    const normalLinks = navContainer.querySelectorAll('.mobile-menu-link:not(.js-country-trigger):not([href="#country"])');
    normalLinks.forEach(link => {
      link.addEventListener('click', function() {
         // Если это якорная ссылка на этой же странице
         const href = this.getAttribute('href');
         if (href && href.includes('#')) closeMenu();
      });
    });
  }

  // --- ФУНКЦИИ ОТКРЫТИЯ/ЗАКРЫТИЯ ---

  function openMenu() {
    renderMain(); // Всегда начинаем с главного меню
    overlay.style.display = 'block';
    document.body.style.overflow = 'hidden';
    
    // Используем requestAnimationFrame для плавного старта анимации
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        overlay.classList.add('is-visible'); // Добавляем класс для opacity
        panel.classList.add('is-open');      // Добавляем класс для transform
      });
    });
  }

  function closeMenu() {
    overlay.classList.remove('is-visible');
    panel.classList.remove('is-open');
    document.body.style.overflow = '';
    
    // Ждем окончания transition (300ms) перед скрытием display: none
    setTimeout(() => {
      overlay.style.display = 'none';
    }, 300);
  }

  // --- ГЛОБАЛЬНЫЕ СЛУШАТЕЛИ ---

  menuToggleButton.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    openMenu();
  });

  closeButton.addEventListener('click', function(e) {
    e.preventDefault();
    closeMenu();
  });

  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) closeMenu();
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && overlay.style.display === 'block') closeMenu();
  });
  
  // Обработка клика по "Select Country" в ДЕСКТОПНОМ хедере
  document.body.addEventListener('click', function(e) {
      const link = e.target.closest('a[href="#country"], button.country-menu-trigger');
      // Проверяем, что клик был НЕ внутри мобильного меню (чтобы не зациклить)
      if (link && !link.closest('#mobile-menu-panel')) {
         e.preventDefault();
         openMenu(); // Открываем панель
         setTimeout(() => renderCountry(), 50); // И переключаем на страны
      }
  });
});





document.addEventListener('DOMContentLoaded', function() {
  var host = window.location.hostname;
  if (host !== 'gorillaenergy.com' && host !== 'www.gorillaenergy.com') return;

  var search = window.location.search;
  if (!search) return;

  var params = new URLSearchParams(search);
  var locale = params.get('locale');
  if (!locale) return;

  var target = null;

  switch (locale) {
    case 'global':
      target = 'https://gorillaenergy.com/';
      break;
    case 'am':
      target = 'https://am.gorillaenergy.com/?lang=en&fl=1';
      break;
    case 'ca':
      target = 'https://ca.gorillaenergy.com/?lang=en';
      break;
    case 'cy':
      target = 'https://cy.gorillaenergy.com/?lang=en';
      break;
    case 'fr':
      target = 'https://fr.gorillaenergy.com/?lang=fr';
      break;
    case 'ge':
      target = 'https://ge.gorillaenergy.com/?lang=en&fl=1';
      break;
    case 'kz':
      target = 'https://kz.gorillaenergy.com/?lang=kz&fl=1';
      break;
    case 'kg':
      target = 'https://kg.gorillaenergy.com/?lang=en&fl=1';
      break;
    case 'md':
      target = 'https://md.gorillaenergy.com/?lang=en&fl=1';
      break;
    case 'ko':
      target = 'https://ko.gorillaenergy.com/?lang=ko';
      break;
    case 'sr':
      target = 'https://sr.gorillaenergy.com/?lang=en';
      break;
    case 'tj':
      target = 'https://tj.gorillaenergy.com/?lang=en&fl=1';
      break;
    case 'gb':
      target = 'https://uk.gorillaenergy.com/?lang=en';
      break;
    case 'uz':
      target = 'https://uz.gorillaenergy.com/?lang=uz&fl=1';
      break;
    case 'ru':
      target = 'https://gorillaenergy.ru/?lang=ru&fl=1';
      break;
    case 'ae':
      target = 'https://ae.gorillaenergy.com/?lang=ar';
      break;
    case 'tr':
      target = 'https://gorillaenergy.com.tr/?lang=tr';
      break;
    case 'us':
      target = 'https://us.gorillaenergy.com';
      break;
    default:
      break;
  }

  if (!target) return;

  window.location.replace(target);
});
